import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function LiveRate(props) {
  const socket = useContext(SocketContext);

  const symbol_id = props.symbol_id;

  const netqty = props.netqty;

  const [Ask, setAsk] = useState(0);
  const [Bid, setBid] = useState(0);

  useEffect(() => {
    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, trade);
    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, []);

  const trade = (data) => {
    if (data != null) {
      setAsk(data.Ask);
      setBid(data.Bid);
    }
  };

  return (
    <div className={`menuBuyPrice`}>
      {netqty > 0 ? parseFloat(Bid) : parseFloat(Ask)}
    </div>
  );
}
